import { Toast } from '@byecode/ui'
import { FlowSelectSourceType, type RecordLikeProtocol } from '@lighthouse/core'
import type { FlowNodeResultADT, UpdateRecordActionConfigure } from '@lighthouse/shared'
import {
    type ActionFlowNode,
    getFindSingleRecordVariableValue,
    getRecordResult,
    getUpdateRecordVariableValue,
    pageStackPubSub,
    type UpdateRecordActionConfig
} from '@lighthouse/shared'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleUpdateRecordStream = async (
    node: ActionFlowNode<UpdateRecordActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const { appId, envId, actionEvents, upstreamNodesResult } = params

    let record: RecordLikeProtocol | null | undefined

    if (config.selectType === FlowSelectSourceType.DATASOURCE) {
        const payload = getFindSingleRecordVariableValue(config, params)
        record = await actionEvents.findSingleRecord(payload)
        if (!record?.id) {
            throw new Error(t('getRecordError'))
        }
    } else {
        record = getRecordResult(upstreamNodesResult?.[config.nodeId])
    }

    if (!record) {
        throw new Error(t('getRecordError'))
    }

    const { fields } = getUpdateRecordVariableValue(record.dsId, config, params)

    const newRecord = await actionEvents.updateRecord({
        appId,
        envId,
        dsId: record.dsId,
        recordId: record.id,
        fields
    })

    if (!newRecord.id) {
        throw new Error(t('updateRecordError'))
    }

    // 更新行以后，需要通知对应订阅更新数据
    pageStackPubSub.emit(`${record.dsId}-ADD`, newRecord)

    return {
        type: 'record',
        success: true,
        data: newRecord
    }
}

export const handleUpdateRecord = async (config: UpdateRecordActionConfig, params: ExecuteActionParams) => {
    const { appId, envId, actionEvents } = params
    const payload = getFindSingleRecordVariableValue(config, params)
    const record = await actionEvents.findSingleRecord(payload)
    if (!record?.id) {
        return
    }

    const { fields } = getUpdateRecordVariableValue(record.dsId, config, params)
    const newRecord = await actionEvents.updateRecord({
        appId,
        envId,
        dsId: record.dsId,
        recordId: record.id,
        fields
    })

    // 更新行以后，需要通知对应订阅更新数据
    pageStackPubSub.emit(`${record.dsId}-ADD`, newRecord)

    Toast.success(t('dataUpdateSuccess'))

    return newRecord
}
